import { z } from 'zod';
import { GEOFENCE_TIPOS } from '../enums.js';
const Lat = z.number().min(-90).max(90);
const Lng = z.number().min(-180).max(180);
const VerticeSchema = z.object({ latitude: Lat, longitude: Lng });
const BaseGeofence = z.object({
    nome: z.string().min(2).max(120),
    tipo: z.enum(GEOFENCE_TIPOS),
    latitudeCentro: Lat.optional(),
    longitudeCentro: Lng.optional(),
    raioMetros: z.number().int().positive().max(50_000).optional(),
    vertices: z.array(VerticeSchema).optional(),
    // null = cerca vale para a empresa toda
    secretariaId: z.string().min(1).nullable().optional(),
    ativa: z.boolean().default(true),
});
const refineGeofence = (data, ctx) => {
    if (data.tipo === 'circulo') {
        if (data.latitudeCentro === undefined || data.longitudeCentro === undefined) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['latitudeCentro'],
                message: 'circulo exige latitudeCentro e longitudeCentro',
            });
        }
        if (data.raioMetros === undefined) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                path: ['raioMetros'],
                message: 'circulo exige raioMetros',
            });
        }
    }
    if (data.tipo === 'poligono' && (!data.vertices || data.vertices.length < 3)) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            path: ['vertices'],
            message: 'poligono exige no minimo 3 vertices',
        });
    }
};
export const CreateGeofenceSchema = BaseGeofence.superRefine(refineGeofence);
export const UpdateGeofenceSchema = BaseGeofence.partial();
// Testa se um ponto cai dentro de uma cerca (ou de todas as ativas, se geofenceId ausente).
export const TestarGeofenceSchema = z.object({
    latitude: Lat,
    longitude: Lng,
    geofenceId: z.string().min(1).optional(),
});
//# sourceMappingURL=geofence.js.map